export type SpacingToken = keyof typeof spacingTokens;

export type SpacingTokens = [
  top?: SpacingToken,
  right?: SpacingToken,
  down?: SpacingToken,
  left?: SpacingToken,
];

export const spacingTokens = {
  "$spacing-0": "0rem",
  "$spacing-2": "0.125rem",
  "$spacing-4": "0.25rem",
  "$spacing-8": "0.5rem",
  "$spacing-10": "0.625rem",
  "$spacing-12": "0.75rem",
  "$spacing-14": "0.875rem",
  "$spacing-16": "1rem",
  "$spacing-20": "1.25rem",
  "$spacing-24": "1.5rem",
  "$spacing-32": "2rem",
  "$spacing-40": "2.5rem",
  "$spacing-48": "3rem",
  "$spacing-56": "3.5rem",
  "$spacing-64": "4rem",
  "$spacing-96": "6rem",
};
